import { vector_3 } from '../../../utility/Conversion.js';
import { LightVisualizer } from './LightVisualizer.js';
import { LightPositionSphere } from './PositionSphere.js';
export class DirectionalLightVisualizer extends LightVisualizer {
    constructor(light, line_manager, color_mode, scene) {
        super(light, line_manager, color_mode, scene);
        this._max_length = 1.5;
        this._tube_radius = 0.15;
        this._num_lines = 8;
        this._minimum_line_length = 0;
        this._position_sphere = new LightPositionSphere('DirectionalLight', scene);
        this.update();
    }
    update() {
        super.update_visualizer();
        const position = vector_3(this._light.get_world_position());
        this._position_sphere.update(position, this._line_color);
        const direction = vector_3(this._light.get_direction());
        this.draw_directional_lines(this.get_line_length(), this._tube_radius, 'tube', this._num_lines, direction, position);
    }
    get_line_length() {
        // Cap line length to between 0 and max_length, with intensity 1 yielding length 1
        // Perhaps a more elegant way to do this exists
        const length = this._max_length * Math.log(this._light.intensity) / (Math.E * Math.E) + 1;
        return Math.max(0, length);
    }
    dispose(start_index = 0) {
        this._position_sphere.dispose();
        super.dispose(start_index);
    }
}
//# sourceMappingURL=DirectionalLightVisualizer.js.map